// src/pages/ThankYouPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GET_WALLET_VERIFY_CASHFREE_ENDPOINT } from "../../config/urls";
import { useAuth } from "../../hooks/AuthProvider";
import Button from '@mui/material/Button';

const MyWalletRedirect = () => {
  const [status, setStatus] = useState("Verifying payment...");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("order_id");

  const { getValidToken } = useAuth();

  useEffect(() => {
    const verifyPayment = async () => {
      const token = await getValidToken();

      const tenant = localStorage.getItem("tenant");
      try {
        const res = await fetch(
          `${GET_WALLET_VERIFY_CASHFREE_ENDPOINT}?order_id=${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "X-Tenant-ID": tenant,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await res.json();
        console.log("Payment verification response:", data);
        console.log("Payment verification status:", res.status);
        console.log("Payment verification order status:", data.order_status);

        if (res.status === 200 && data.order_status === "SUCCESS") {
          setStatus("✅ Payment successful! Funds have been added.");

        } else if( res.status === 200 && data.order_status === "PENDING") {
          setStatus(data.message || "⚠️ Payment is still pending.");
        }
        else if (res.status === 200 && data.order_status === "USER_DROPPED") {
          setStatus("❌ Payment failed. Please try again.");
        }
        else if (res.status === 200 && data.order_status === "FAILED") {
          setStatus("❌ Payment failed. Please try again.");
        }
        else if (res.status === 200 && data.order_status === "CANCELLED") {
          setStatus("❌ Payment was cancelled. Please try again.");
        }
        else if (res.status === 200 && data.order_status === "VOID") {
          setStatus("❌ Payment was voided. Please try again.");
        }
        else if (res.status === 200 && data.order_status === "NOT_ATTEMPTED") {
          setStatus("❌ Payment was not attempted. Please try again.");
        }
        else if (res.status === 200 && data.order_status === "FLAGGED") {
          setStatus("⚠️ Payment flagged for review. Please contact support.");
        }
        else if (res.status === 200 && data.order_status === "INCOMPLETE") {
          setStatus("⚠️ Payment is incomplete. Please try again.");
        }
        else {
          setStatus("⚠️ Unable to verify payment. Please try again later.");
        }
      } catch (err) {
        setStatus("❌ An error occurred while verifying the payment.");
        console.error(err);
      }
    };

    if (orderId) {
      verifyPayment();
    } else {
      setStatus("⚠️ No order ID provided.");
    }
  }, [orderId]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Thank You!</h2>
      <p>{status}</p>
      <Button
        variant="contained"
        onClick={() => navigate("/")}
        style={{ marginTop: "20px" }}
        disabled={status.includes("Verifying payment...")}
      >
        Go to Dashboard
      </Button>
    </div>
  );
};

export default MyWalletRedirect;
